class SearchPageController {
  initialize({ newsBlogId, resourcesBlogId, newsBlogBaseUrl, resourcesBlogBaseUrl }) {
    const sections = [
      { label: 'All', section: 'all', queryParams: 'type=all' },
      { label: 'Products', section: 'Products', queryParams: 'type=products' },
      { label: 'Resources', section: resourcesBlogId, queryParams: `type=blog&blogId=${resourcesBlogId}` },
      { label: 'News', section: newsBlogId, queryParams: `type=blog&blogId=${newsBlogId}` },
    ];
    const locationSearchParams = new URLSearchParams(location.search);
    const defaultSection =
      sections.find((section) => section.section === locationSearchParams.get('section')) || sections[0];
    const app = new Vue({
      el: '#search-container',
      delimiters: ['${', '}'],
      data: {
        pageInfo: {
          currentPage: locationSearchParams.get('page') || 1,
          data: [],
          perPage: 20,
          total: 0,
          totalPages: 1,
        },
        sections,
        selectedSection: defaultSection,
        search: locationSearchParams.get('q') || '',
        resolvedSearch: locationSearchParams.get('q') || '',
        loading: false,
      },
      mounted() {
        this.fetchData();
      },
      filters: {
        truncate: function (text, maxWords) {
          return text?.split(' ').splice(0, maxWords).join(' ');
        },
        stripHtml: function (text) {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          return doc.body.textContent || '';
        },
      },
      methods: {
        isValidUrl(string) {
          try {
            new URL(string);
          } catch (_) {
            return false;
          }
          return true;
        },
        sectionVisible: function (filterId) {
          return ['all', filterId.toLowerCase()].includes(this.selectedSection.label.toLowerCase());
        },
        currentlyPaginating() {
          if (this.pageInfo.total == 0) {
            return `0 - 0`;
          }
          const min = (this.pageInfo.currentPage - 1) * this.pageInfo.perPage + 1;
          const max =
            this.pageInfo.currentPage < this.pageInfo.totalPages
              ? this.pageInfo.currentPage * this.pageInfo.perPage
              : min - 1 + this.pageInfo.data.length;
          return `${min} - ${max}`;
        },
        onSectionSelected(section) {
          this.selectedSection = section;
          this.fetchData();
        },
        sectionLabel({ section }) {
          return sections.find((it) => it.section.toUpperCase() === section.toUpperCase())?.label || 'Unknown';
        },
        isTagSelected: function (tagGroup, tag) {
          const searchParams = new URLSearchParams(location.search);
          const value = searchParams.get(tagGroup);
          return value && value === tag;
        },
        toggleTag: function (tagGroup, tag) {
          if (this.isTagSelected(tagGroup, tag)) {
            this.setUrlLocation('replace', { [tagGroup]: null, page: 1 });
          } else {
            this.setUrlLocation('replace', { [tagGroup]: tag, page: 1 });
          }
          this.pageInfo.currentPage = 1;
          this.fetchData();
        },
        getUrl({ section, itemType, url }) {
          if (this.isValidUrl(url)) {
            return url;
          }
          if (itemType === 'blog') {
            const baseUrl = section === newsBlogId ? newsBlogBaseUrl : resourcesBlogBaseUrl;
            return `${baseUrl}/${url}`;
          }
          return url;
        },
        setCursorOnFocus: function (focusEvent) {
          setTimeout(() => {
            const length = focusEvent.srcElement.value.length;
            focusEvent.srcElement.setSelectionRange(length, length);
          }, 150);
        },
        sendSearch: function (ev) {
          if (ev.keyCode !== 13) {
            return;
          }
          this.setUrlLocation('push', { q: this.search, page: 1 });
          this.pageInfo.currentPage = 1;
          this.fetchData();
        },
        onNext: function () {
          const nextPage = parseInt(this.pageInfo.currentPage) + 1;
          if (nextPage <= this.pageInfo.totalPages) {
            this.pageInfo.currentPage = nextPage;
            this.setUrlLocation('push', { page: nextPage });
            this.fetchData();
          }
        },
        onPrev: function () {
          const prevPage = parseInt(this.pageInfo.currentPage) - 1;
          if (prevPage > 0) {
            this.pageInfo.currentPage = prevPage;
            this.setUrlLocation('push', { page: prevPage });
            this.fetchData();
          }
        },
        onPage: function (page) {
          this.pageInfo.currentPage = page;
          this.setUrlLocation('push', { page });
          this.fetchData();
        },
        setUrlLocation(pushOrReplace, updates) {
          const { protocol, host, pathname, search } = location;
          const params = new URLSearchParams(search);
          for (const key of Object.keys(updates)) {
            if (updates[key]) {
              params.set(key, updates[key]);
            } else {
              params.delete(key);
            }
          }
          let newurl = `${protocol}//${host + pathname}?${params.toString()}`;
          if (pushOrReplace === 'push') {
            window.history.pushState({ path: newurl }, '', newurl);
          } else if (pushOrReplace === 'replace') {
            window.history.replaceState({ path: newurl }, '', newurl);
          }
        },
        getLang: () => {
          console.log(
            JSON.parse(window.localStorage.getItem('@Cytek/PreferredLanguageById'))?.Anon?.locale?.toLowerCase()
          );
          return JSON.parse(window.localStorage.getItem('@Cytek/PreferredLanguageById'))?.Anon?.locale?.toLowerCase();
        },
        fetchData: function () {
          const params = new URLSearchParams(this.selectedSection.queryParams);
          const currentSearchParams = new URLSearchParams(location.search);
          for (const [paramName, paramValue] of currentSearchParams.entries()) {
            if (paramName !== 'section' && paramName !== '_gl' && paramValue) {
              params.set(paramName, paramValue);
              console.log(`${paramName}: ${paramValue}`);
            }
          }
          params.set('page', this.pageInfo.currentPage);
          params.set('limit', this.pageInfo.perPage);
          params.set('q', String(this.search).trim());
          params.set('location', this.getLang() === 'usa' ? 'usa-only' : 'int-only');
          console.log(params.toString());
          this.loading = true;
          return jQuery
            .get(`${Cytek.SERVER_BASE_URL}/api/search?${params.toString()}`)
            .done((val) => {
              this.pageInfo = val;
              this.resolvedSearch = params.get('q');
              this.setUrlLocation(this.resolvedSearch, this.pageInfo.currentPage);
            })
            .fail((error) => {
              console.error(error);
            })
            .always(() => {
              this.loading = false;
            });
        },
      },
    });
  }
}
